/* 
In this file we have routed the routes to its respective pages. We have different routes for different pages like for login/signup page, service 
inventory page, platform dashboard page, customer solution page. 
*/

import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Login from "../pages/LoginPage.js";
import ServiceInv from "../pages/ServiceInventoryPage.js";
import PltVersionTable from "../pages/PltversionPage.js";
import CsVersionTable from "../pages/CsVersionPage.js";
import NodeUsagePage from "../pages/NodeUsagePage.js";
import HarnessUserPage from "../pages/HarnessUserPage.js";
import ProtectedRoute from "../components/ProtectedRoute/ProtectedRoute.js"; 


function AllRoutes() {
    return (
        <BrowserRouter>
            <Routes>  
                <Route path="/" element={<Login />} />
                <Route 
                    path="/svc-inventory" 
                    element={<ProtectedRoute><ServiceInv /></ProtectedRoute>} 
                />
                <Route 
                    path="/plt-version" 
                    element={<ProtectedRoute><PltVersionTable /></ProtectedRoute>} 
                />
                <Route 
                    path="/cs-version" 
                    element={<ProtectedRoute><CsVersionTable /></ProtectedRoute>} 
                />
                <Route 
                    path="/node-usage" 
                    element={<ProtectedRoute><NodeUsagePage /></ProtectedRoute>} 
                />
                <Route 
                    path="/harness-user" 
                    element={<ProtectedRoute><HarnessUserPage /></ProtectedRoute>} 
                />
            </Routes>
        </BrowserRouter>       
    );
}

export default AllRoutes;
